import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pheme',
  templateUrl: './pheme.component.html',
  styleUrls: ['./pheme.component.css']
})
export class PhemeComponent implements OnInit {
  phemePath:any;
  loginKey:any;
  loginName:any
  phemeURL=environment.phemeURL;
  agoraConfigObject: any;
  constructor(private sanitizier:DomSanitizer, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints; 
    this.phemeURL = this.agoraConfig.getConfig().apiBaseUrl+this.agoraConfigObject.pheme;
    //let phemeurl="https://cloudapps1-us-app3.stafa-ct.com/Pheme373/login.action";
  }

  ngOnInit(): void {
    this.loginKey=localStorage.getItem('loginKey');
    this.loginName=localStorage.getItem('loginName');
    //let phemeurl = "https://demo.ncoup.com/nCartesPheme/ValidateUser.action?crossOrgin=true&lazyLoad=true&userName=ysunita&loginKey=XbB6CJOi3iL5Be4Oj5u4RQ==";
    let phemeurl = this.phemeURL + "/ValidateUser.action?userName="+this.loginName+"&loginKey="+encodeURIComponent(this.loginKey);
 
     this.phemePath= this.sanitizier.bypassSecurityTrustResourceUrl(phemeurl);
  }

}
